import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ErrorBoundary } from "./components/error-boundary";
import { AuthInitializer } from "./shared/components/auth-initializer";
import { ToastProvider } from "./client/components/common/toast";
import { QueryProvider } from "./lib/query-provider";
import { router } from "./router";
import "./styles/globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <AuthInitializer>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </AuthInitializer>
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>,
);
